import { apiEndpoints } from '@/apiEndpoints';
import { CarRentalResponse } from '@/types/benefits/carRental/CarRentalResponse';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

export const createCarRental = async (data: FormData) =>
  axios.post(apiEndpoints.carRentals.base, data);

export const updateCarRental = async (
  benefitId: string,
  data: FormData,
  language?: SupportedLocale,
) =>
  axios.put(apiEndpoints.carRentals.detail(benefitId), data, {
    params: { language },
  });

export const getCarRental = async (benefitId: string) => {
  const result = await axios.get<CarRentalResponse>(
    apiEndpoints.carRentals.detail(benefitId),
  );
  return result.data;
};

export const duplicateCarRental = async (
  benefitId: string,
  fields: string[],
) => {
  const result = await axios.post(
    apiEndpoints.carRentals.duplicate(benefitId),
    { fields },
  );
  return result.data;
};
